import AuctanePayCommunication from './../../utils/AuctanePayCommunication';

// Mock ApiConfig implementation
const apiConfig = {
	getSessionId: async data => {
		return AuctanePayCommunication.getAPSession(data);
	},

	getAPConfig: async data => {
		const response = await AuctanePayCommunication.getAPConfig(data);

		return response.data;
	},
};

export default apiConfig;
